import { render, staticRenderFns } from "./pc-showcase.vue?vue&type=template&id=0066a9d7&"
import script from "./pc-showcase.vue?vue&type=script&lang=js&"
export * from "./pc-showcase.vue?vue&type=script&lang=js&"
import style0 from "./pc-showcase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports